export type Attribute = { name: string; line: string };

export const attributes: Attribute[] = [
  { name: "Precision", line: "Nothing approximate. Every figure earns its place." },
  { name: "Composure", line: "Deadlines meet no urgency in our hands." },
  { name: "Rigor", line: "Standards that hold up when no one is watching." },
  { name: "Continuity", line: "The same care, every cycle, without exception." },
  { name: "Discretion", line: "Judgment exercised quietly, never announced." },
  { name: "Clarity", line: "Said once, said correctly, never repeated." },
];

export type Statement = { title: string; line: string };

export const whatWeAre: Statement[] = [
  { title: "Operators who run payroll", line: "We process it, fix it, and keep it covered." },
  { title: "Implementers who work inside the systems", line: "We configure HRIS and payroll platforms ourselves." },
  { title: "A firm that stays", line: "We fix what’s broken, then keep it working." },
];

export const notList: string[] = [
  "A generic HR consulting firm",
  "A payroll software company",
  "A PEO",
  "A basic payroll processor",
  "A staffing company",
];

export type Audience = { role: string; need: string };

export const audiences: Audience[] = [
  { role: "CFOs & Controllers", need: "Payroll that’s right, reconciliations that tie out, and checks that hold up at audit." },
  { role: "CHROs & HR Leaders", need: "HR systems that work for employees, and a team that isn’t constantly catching up." },
  { role: "Payroll & HRIS Leaders", need: "Senior backup, clear documentation, and experienced hands inside the system." },
  { role: "COOs & Founders", need: "Payroll and HR technology that grow with the business without depending on one person." },
];

export type WorkStep = { number: string; name: string; line: string };

export const workSteps: WorkStep[] = [
  { number: "01", name: "Assess", line: "We find out what’s actually happening — the next pay date, the systems, the people, and the risks." },
  { number: "02", name: "Stabilize", line: "Anything at risk this cycle gets fixed first. People get paid correctly while the work happens." },
  { number: "03", name: "Document", line: "We write down how it works, so it doesn’t live in one person’s head." },
  { number: "04", name: "Fix & build", line: "We correct the setup, improve the process, and build what’s missing." },
  { number: "05", name: "Keep it running", line: "We run it for you, or hand it back clean — with everything written down." },
];
